export class SAML2Attribute {
    name: string;
    userAttributeMapping: string;
    attributeTransformationsRegex: string;
    attributeValidationsRegex: string;
    values: string;
    skipIfBlank: boolean;
    defaultValues: string;
    label: string;

    constructor() {
        this.name = '';
        this.userAttributeMapping = '';
        this.attributeTransformationsRegex = '';
        this.attributeValidationsRegex = '';
        this.values = '';
        this.skipIfBlank = false;
        this.defaultValues = '';
        this.label = '';
    }
}